module.exports = __webpack_public_path__ + "static/media/tecnologia.b05b447c.png";